// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k9hHc5qbqFHalO_fhzAh {
    background: rgba(225, 235, 255, 0.4);
}

.BKi4MFdknGPQnnQAhQUW {
    min-height: 30px;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    transition: all 0.5s ease-in;
}

.RqUtSqbMSd2j165hKgoT {
    width: 10px;
    height: 11px;
    border-radius: 1px;
}

.udU28jVUUYK5j2EDT7az {
    max-height: 350px;
    overflow-y: scroll;
}

.SK6ykmhRjIxhN3SA7i_i {
    font-family: 'Inter', sans-serif;
    border-collapse: collapse;
    width: 100%;
}

.SK6ykmhRjIxhN3SA7i_i th,
.SK6ykmhRjIxhN3SA7i_i td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: left;
}

.SK6ykmhRjIxhN3SA7i_i th {
    background-color: #f2f2f2;
    position: sticky;
    top: 0;
    z-index: 2;
}

.SK6ykmhRjIxhN3SA7i_i tbody {
    max-height: 300px;
}

.zuD2nNrN4ayXK9Wo7gH3 {
    display: flex;
    align-items: flex-start;
    font-family: 'Inter', sans-serif;
    padding: 4px;
    padding-bottom: 0px;
}

.Qp5rib_C0FZrtNPGZaxv {
    list-style: none;
    padding: 16px;
    padding-top: 0px;
    padding-bottom: 0px;
    margin-right: 4px;
}

.iZ_w7FGuldlAM0TzWIHY {
    cursor: pointer;
    margin-bottom: 8px;
    padding: 18px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    background-color: #ddd;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.iZ_w7FGuldlAM0TzWIHY:last-child {
    border-bottom: none;
    margin-bottom: 0px;
}

.GkjXteVUqKXvypsrYbk0 {
    background-color: white;
    width: 125%;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}

.B_cOZ5CoJRuQw6pE_o7Z {
    font-size: 15px;
    font-weight: bold;
}

.jtjGRKSAd_35mEY1kw6Z {
    margin-bottom: 8px;
    font-weight: normal;
    color: grey;
    font-size: 13px;
}

.rkH3KaHpqYX7khd96LFQ {
    text-transform: capitalize;
    margin-bottom: 4px;
    display: flex;
    font-size: 16px !important;
}

.wGqDSdg0yUV5yEbdvy32 {
    padding-left: 6px;
}

.UuAK_IxB9RBHauVMecF6 {
    margin-bottom: 10px;
    font-size: 16px;
}

.tY7h50D9xh0rBG29yCE0 {
    flex: 2;
    display: flex;
    flex-direction: column;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;
    border-radius: 6px;
    min-height: 300px;
}

.KrbOSr4hM44FjCUUANuT {
    display: grid;
    list-style: none;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 18px;
    padding: 14px;
}

.UNyjmyzoddneD763awa2 {
    text-align: center;
    border: 1px solid;
    border-radius: 6px;
    padding: 8px;
    border-color: lightgrey;
    margin: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
}

.h8UFwyBLO_DKZocY94rr {
    font-weight: bold;
}

.ZhHVYnKMpcgBrCKjpbOf {
    margin-bottom: 8px;
    font-weight: normal;
    color: grey;
    font-size: 12px;
}

.PnbzY8xgrl90ibwwwxFu {
    font-size: 14px;
    color: grey;
}

.LajTdPTcNEm4XC2znz5e {
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
}

.WJc_udvSuB9FUqJDAEkT {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.dCVnyTNk4_1qkRGLoai2 {
    width: 5px;
    height: 5px;
    border-radius: 50%;
}

.XCK9ObWD3ElscfuvUhI1 {
    display: flex;
    flex-direction: column;
}

.wtOf8Zjq_hyRdLlbycsd,
.JpjccKGyS3JZnzKHRWZd {
    font-size: 12px;
    color: #666;
}

._62c28izHQFxZ9ZW8ghJA {
    margin-bottom: 8px;
}

.dT8hrs8J2UCtCd0ZLtVn {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
}

.sPfKUtx_BDunfZ6exAo7 {
    display: inline-block;
    width: 8px;
    height: 8px;
    margin-right: 4px;
    border-radius: 1px;
}

.kuc_P4YE9K_EKQ08Fert {
    color: black;
    font-size: 11px;
    font-family: 'Inter', sans-serif;
}

.igMYqWLe5x7V8b8trpvz {
    color: grey;
    font-size: 11px;
    font-family: 'Inter', sans-serif;
}

.ufhcR2lC4hflktooLj82 {
    color: black;
    font-size: 10px;
}

.lbLrPrDKdABBB7HTX7XV {
    display: flex;
    justify-content: space-between;
    margin-left: 8px;
    margin-bottom: 10px;
    margin-top: -15px;
}

.TjTznujk71pQZHs2jN2C {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 8px;
}

.F1lbI8sVNOPagILsvQFj {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.JDG08l5ygH6T0fxN7jmz {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
}

.L2grTwYT8Jt0ZTA0b1ol {
    display: flex;
    align-items: center;
    margin-right: 10px;
}

.LhnzQwSm4_5Fe3dnTIi3 {
    width: 12px;
    height: 12px;
    border-radius: 0.25rem;
    margin-right: 8px;
}

.e43jUtiTT4pDL7BFiPli {
    color: rgb(107, 114, 128);
    font-size: 12px;
    font-weight: 400;
    font-family: Inter, sans-serif;
    margin-right: 4px;
}

.gNoZPeCmLm_UheQbDj4v {
    position: relative;
    display: inline-block;
    cursor: pointer;
    margin-right: 10px;
}

.wGqDSdg0yUV5yEbdvy32 {
    font-size: 13px;
    padding: 6px 8px;
    width: 180px;
    color: #fff;
    line-height: 1.5rem;
    text-align: start;
    text-decoration: none;
    word-wrap: break-word;
    background-color: rgba(0, 0, 0, 0.85);
    border-radius: 8px;
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    visibility: hidden;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
}

.gNoZPeCmLm_UheQbDj4v:hover .wGqDSdg0yUV5yEbdvy32 {
    visibility: visible;
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/pages/analytics/styles.module.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,4BAA4B;IAC5B,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gCAAgC;IAChC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;IACtB,mDAAmD;AACvD;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,qDAAqD;AACzD;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iDAAiD;IACjD,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,qCAAqC;IACrC,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,qCAAqC;IACrC,kBAAkB;IAClB,oHAAoH;IACpH,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,UAAU;AACd","sourcesContent":[".funnelWrapper {\n    background: rgba(225, 235, 255, 0.4);\n}\n\n.column {\n    min-height: 30px;\n    border-top-right-radius: 4px;\n    border-top-left-radius: 4px;\n    transition: all 0.5s ease-in;\n}\n\n.legend {\n    width: 10px;\n    height: 11px;\n    border-radius: 1px;\n}\n\n.tableWrapper {\n    max-height: 350px;\n    overflow-y: scroll;\n}\n\n.distributionTable {\n    font-family: 'Inter', sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.distributionTable th,\n.distributionTable td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: left;\n}\n\n.distributionTable th {\n    background-color: #f2f2f2;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n}\n\n.distributionTable tbody {\n    max-height: 300px;\n}\n\n.failureReasonsContainer {\n    display: flex;\n    align-items: flex-start;\n    font-family: 'Inter', sans-serif;\n    padding: 4px;\n    padding-bottom: 0px;\n}\n\n.categoriesList {\n    list-style: none;\n    padding: 16px;\n    padding-top: 0px;\n    padding-bottom: 0px;\n    margin-right: 4px;\n}\n\n.categoryItem {\n    cursor: pointer;\n    margin-bottom: 8px;\n    padding: 18px;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: space-between;\n    background-color: #ddd;\n    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\n}\n\n.categoryItem:last-child {\n    border-bottom: none;\n    margin-bottom: 0px;\n}\n\n.categoryItemSelected {\n    background-color: white;\n    width: 125%;\n    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;\n}\n\n.failureCount {\n    font-size: 15px;\n    font-weight: bold;\n}\n\n.failurePercentage {\n    margin-bottom: 8px;\n    font-weight: normal;\n    color: grey;\n    font-size: 13px;\n}\n\n.categoryName {\n    text-transform: capitalize;\n    margin-bottom: 4px;\n    display: flex;\n    font-size: 16px !important;\n}\n\n.tooltip {\n    padding-left: 6px;\n}\n\n.rightPanelHeader {\n    margin-bottom: 10px;\n    font-size: 16px;\n}\n\n.rightPanel {\n    flex: 2;\n    display: flex;\n    flex-direction: column;\n    background-color: white;\n    box-shadow: rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px;\n    border-radius: 6px;\n    min-height: 300px;\n}\n\n.failureReasonsList {\n    display: grid;\n    list-style: none;\n    grid-template-columns: repeat(2, 1fr);\n    grid-gap: 18px;\n    padding: 14px;\n}\n\n.failureReasonItem {\n    text-align: center;\n    border: 1px solid;\n    border-radius: 6px;\n    padding: 8px;\n    border-color: lightgrey;\n    margin: 4px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 4px;\n}\n\n.failureReasonCount {\n    font-weight: bold;\n}\n\n.failureReasonPercentage {\n    margin-bottom: 8px;\n    font-weight: normal;\n    color: grey;\n    font-size: 12px;\n}\n\n.failureReason {\n    font-size: 14px;\n    color: grey;\n}\n\n.noFailureReasons {\n    font-size: 14px;\n    margin-top: 10px;\n    text-align: center;\n}\n\n.paymentMethod {\n    display: flex;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.circle {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n}\n\n.info {\n    display: flex;\n    flex-direction: column;\n}\n\n.count,\n.percentage {\n    font-size: 12px;\n    color: #666;\n}\n\n.category {\n    margin-bottom: 8px;\n}\n\n.colorCircle {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    margin-right: 4px;\n}\n\n.colorSquare {\n    display: inline-block;\n    width: 8px;\n    height: 8px;\n    margin-right: 4px;\n    border-radius: 1px;\n}\n\n.categoryNames {\n    color: black;\n    font-size: 11px;\n    font-family: 'Inter', sans-serif;\n}\n\n.labelName {\n    color: grey;\n    font-size: 11px;\n    font-family: 'Inter', sans-serif;\n}\n\n.categoryLabel {\n    color: black;\n    font-size: 10px;\n}\n\n.legendContainer {\n    display: flex;\n    justify-content: space-between;\n    margin-left: 8px;\n    margin-bottom: 10px;\n    margin-top: -15px;\n}\n\n.legendStep {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 0 8px;\n}\n\n.legendItem {\n    display: flex;\n    align-items: center;\n    margin-bottom: 5px;\n}\n\n.chartSeriesInfo {\n    display: flex;\n    flex-direction: row;\n    margin-top: 5px;\n}\n\n.seriesItem {\n    display: flex;\n    align-items: center;\n    margin-right: 10px;\n}\n\n.colorBox {\n    width: 12px;\n    height: 12px;\n    border-radius: 0.25rem;\n    margin-right: 8px;\n}\n\n.seriesLabel {\n    color: rgb(107, 114, 128);\n    font-size: 12px;\n    font-weight: 400;\n    font-family: Inter, sans-serif;\n    margin-right: 4px;\n}\n\n.infoIcon {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    margin-right: 10px;\n}\n\n.tooltip {\n    font-size: 13px;\n    padding: 6px 8px;\n    width: 180px;\n    color: #fff;\n    line-height: 1.5rem;\n    text-align: start;\n    text-decoration: none;\n    word-wrap: break-word;\n    background-color: rgba(0, 0, 0, 0.85);\n    border-radius: 8px;\n    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);\n    box-sizing: border-box;\n    visibility: hidden;\n    position: absolute;\n    z-index: 1;\n    bottom: 125%;\n    opacity: 0;\n    transition: opacity 0.3s;\n}\n\n.infoIcon:hover .tooltip {\n    visibility: visible;\n    opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"funnelWrapper": `k9hHc5qbqFHalO_fhzAh`,
	"column": `BKi4MFdknGPQnnQAhQUW`,
	"legend": `RqUtSqbMSd2j165hKgoT`,
	"tableWrapper": `udU28jVUUYK5j2EDT7az`,
	"distributionTable": `SK6ykmhRjIxhN3SA7i_i`,
	"failureReasonsContainer": `zuD2nNrN4ayXK9Wo7gH3`,
	"categoriesList": `Qp5rib_C0FZrtNPGZaxv`,
	"categoryItem": `iZ_w7FGuldlAM0TzWIHY`,
	"categoryItemSelected": `GkjXteVUqKXvypsrYbk0`,
	"failureCount": `B_cOZ5CoJRuQw6pE_o7Z`,
	"failurePercentage": `jtjGRKSAd_35mEY1kw6Z`,
	"categoryName": `rkH3KaHpqYX7khd96LFQ`,
	"tooltip": `wGqDSdg0yUV5yEbdvy32`,
	"rightPanelHeader": `UuAK_IxB9RBHauVMecF6`,
	"rightPanel": `tY7h50D9xh0rBG29yCE0`,
	"failureReasonsList": `KrbOSr4hM44FjCUUANuT`,
	"failureReasonItem": `UNyjmyzoddneD763awa2`,
	"failureReasonCount": `h8UFwyBLO_DKZocY94rr`,
	"failureReasonPercentage": `ZhHVYnKMpcgBrCKjpbOf`,
	"failureReason": `PnbzY8xgrl90ibwwwxFu`,
	"noFailureReasons": `LajTdPTcNEm4XC2znz5e`,
	"paymentMethod": `WJc_udvSuB9FUqJDAEkT`,
	"circle": `dCVnyTNk4_1qkRGLoai2`,
	"info": `XCK9ObWD3ElscfuvUhI1`,
	"count": `wtOf8Zjq_hyRdLlbycsd`,
	"percentage": `JpjccKGyS3JZnzKHRWZd`,
	"category": `_62c28izHQFxZ9ZW8ghJA`,
	"colorCircle": `dT8hrs8J2UCtCd0ZLtVn`,
	"colorSquare": `sPfKUtx_BDunfZ6exAo7`,
	"categoryNames": `kuc_P4YE9K_EKQ08Fert`,
	"labelName": `igMYqWLe5x7V8b8trpvz`,
	"categoryLabel": `ufhcR2lC4hflktooLj82`,
	"legendContainer": `lbLrPrDKdABBB7HTX7XV`,
	"legendStep": `TjTznujk71pQZHs2jN2C`,
	"legendItem": `F1lbI8sVNOPagILsvQFj`,
	"chartSeriesInfo": `JDG08l5ygH6T0fxN7jmz`,
	"seriesItem": `L2grTwYT8Jt0ZTA0b1ol`,
	"colorBox": `LhnzQwSm4_5Fe3dnTIi3`,
	"seriesLabel": `e43jUtiTT4pDL7BFiPli`,
	"infoIcon": `gNoZPeCmLm_UheQbDj4v`
};
export default ___CSS_LOADER_EXPORT___;
